"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/phone-number`;
    }
    /**
     * Returns the list of phone numbers that are used by a particular extension,
   * can be filtered by the phone number type. The returned list contains all
   * numbers which are directly mapped to the given extension. Plus the features
   * and company-level numbers that may be used when performing different operations
   * on behalf of this extension.
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/phone-number
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserPhoneNumbers
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map